import 'edge/endorsement/app';
import ctrl from './controllers/EndorsementEntryCtrl';
import template from 'text!./views/endorsement-entry.html';
import _ from 'lodash';

export default angular.module('edge.gateway.endorsement.common.app', ['edge.endorsement.app'])
    .run(['$state', ($state) => {
        ['endorsement', 'endorsementWithPolicy'].forEach(stateName => {
            const state = $state.get(stateName);
            const editedState = _.cloneDeep(state);
            editedState.views[''].template = template;
            editedState.views[''].controller = ctrl;
            $state.router.stateRegistry.deregister(stateName);
            $state.router.stateRegistry.register(editedState);
        });
    }]);